module.exports = __webpack_public_path__ + "img/banner1.00144996.jpg";